// src/tracker/components/IncomeSpendingLineChart.js

import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const IncomeSpendingLineChart = ({ data }) => {
    const theme = useTheme();
    const formatYAxis = (tickItem) => `₱${tickItem / 1000}k`;

    // Check for less than 2 data points to draw a line
    if (!data || data.length < 2) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Typography color="text.secondary">Add transactions for at least two different months to see a trend.</Typography>
            </Box>
        );
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart
                data={data}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
                <XAxis dataKey="month" stroke={theme.palette.text.secondary} />
                <YAxis tickFormatter={formatYAxis} stroke={theme.palette.text.secondary} />
                <Tooltip
                    formatter={(value, name) => [`₱${Number(value).toLocaleString()}`, name]}
                    contentStyle={{
                        backgroundColor: theme.palette.mode === 'dark' ? '#0f172a' : '#ffffff',
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: 8,
                        color: theme.palette.text.primary,
                    }}
                    labelStyle={{ color: theme.palette.text.secondary }}
                />
                <Legend wrapperStyle={{ color: theme.palette.text.secondary }} />
                <Line type="monotone" dataKey="Income" stroke={theme.palette.success.main} strokeWidth={3} activeDot={{ r: 6 }} />
                <Line type="monotone" dataKey="Spending" stroke={theme.palette.error.main} strokeWidth={3} />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default IncomeSpendingLineChart;
